import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import { fetchProducts, deleteProduct, clearProductsErrors } from '../../actions';
import DialogModal from '../home/DialogModal';
import ActionButtons from '../home/ActionButtons';
import Alert from '../home/Alert';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';
import Checkbox from 'material-ui/Checkbox';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  products: PropTypes.any,
  productsList: PropTypes.object.isRequired,
  productDelete: PropTypes.bool,
  onProductDisable: PropTypes.func.isRequired,
};

class ShowProducts extends Component {
  constructor() {
    super();
    this.state = {
      open: false,
      deleteId: 0,
      alertOpen: false,
      alertMessage: '',
      delete: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.productDelete && (this.state.delete || nextProps.products.delete)) {
      const products = nextProps.products;
      products.delete = false;
      this.setState({
        delete: false,
        alertOpen: true,
        alertMessage: 'Product deleted!',
        products,
      });
      this.handleClose();
    }
    if (nextProps.error) {
      this.setState({
        delete: false,
        alertOpen: true,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
      });
    }
  }
  handleOpen(id) {
    this.setState({
      open: true,
      deleteId: id,
    });
  }
  handleClose() {
    this.setState({
      open: false,
      deleteId: 0,
    });
  }
  handleDelete() {
    this.setState({
      delete: true,
    });
    this.props.dispatch(deleteProduct(this.state.deleteId));
    this.props.dispatch(fetchProducts());
  }
  handleDisable(item) {
    const data = item;
    data.disabled = !item.disabled;
    this.props.onProductDisable(data);
  }
  alertHandleClose() {
    this.setState({
      alertMessage: '',
      alertOpen: false,
    });
    this.props.dispatch(clearProductsErrors());
    this.props.dispatch(fetchProducts());
  }
  renderRowsTable() {
    return this.props.productsList.results.map(item =>
      <TableRow key={item.id}>
        <TableRowColumn style={{ width: '20%' }} key={item.id}>{item.name}</TableRowColumn>
        <TableRowColumn style={{ width: '40%' }} key={item.id}>{item.description}</TableRowColumn>
        <TableRowColumn style={{ paddingLeft: '5%', width: '10%' }} key={item.id}>
          <Checkbox
            style={{ width: '40px' }}
            checked={item.allowsPersonalization}
          />
        </TableRowColumn>
        <TableRowColumn key={item.id} style={{ width: '20%' }}>
          <ActionButtons
            onEdit={`/products/${item.id}`}
            onView={`/products/view/${item.id}`}
            onDelete={() => this.handleOpen(item.id)}
            onDisable={() => this.handleDisable(item)}
            disabled={item.disabled}
            disableForOperators
          />
        </TableRowColumn>
      </TableRow>
    );
  }
  render() {
    const tableStyles = {
      stripedRows: true,
      displaySelectAll: false,
      adjustForCheckbox: false,
      selectable: false,
      displayRowCheckbox: false,
    };
    return (
      <div>
        <DialogModal
          dialogOpen={this.state.open}
          dialogHandleClose={this.handleClose}
          dialogHandleSubmit={() => this.handleDelete()}
          dialogTitle="Delete Product"
          dialogMessage="Do you really want to delete this product?"
          dialogActionTitle="Delete"
        />
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <Table selectable={false}>
          <TableHeader
            displaySelectAll={tableStyles.displaySelectAll}
            adjustForCheckbox={tableStyles.adjustForCheckbox}
          >
            <TableRow
              selectable={tableStyles.selectable}
            >
              <TableHeaderColumn style={{ width: '20%' }}>Name</TableHeaderColumn>
              <TableHeaderColumn style={{ width: '40%' }}>Description</TableHeaderColumn>
              <TableHeaderColumn style={{ width: '10%' }}>Allows Personalization</TableHeaderColumn>
              <TableHeaderColumn style={{ width: '20%', textAlign: 'center' }}>Actions</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody
            stripedRows={tableStyles.stripedRows}
            displayRowCheckbox={tableStyles.displayRowCheckbox}
          >
            {this.renderRowsTable()}
          </TableBody>
        </Table>
      </div>
    );
  }
}

ShowProducts.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

ShowProducts.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    productDelete: state.products.productDelete,
    error: state.products.error,
    products: state.products,
  };
}

export default connect(mapStateToProps)(ShowProducts);



// WEBPACK FOOTER //
// ./src/components/products/ShowProducts.js